import { separateFullName } from "@lib/utils/address";
import type { CountryCode } from "@config/site/types";
import type { CustomerAddressResponse } from "@interfaces/heap-api";
import type { DeliveryInitialValues } from "@lib/utils/checkoutHelper";

// Explicit mapping keeps profile metadata out of checkout/cart operations.
export const mapProfileAddressToCheckout = (
    address: CustomerAddressResponse | null | undefined,
    country: CountryCode
): DeliveryInitialValues | null => {
    if (!address) return null;
    const [firstName, lastName] = separateFullName(address.fullName, country);
    return {
        firstName,
        lastName,
        streetName: address.street ?? "",
        additionalAddressInfo: address.additionalAddressInfo ?? "",
        postalCode: address.postalCode ?? "",
        city: address.city ?? "",
        region: address.region ?? "",
        district: address.district ?? "",
        phoneticFirstName: address.phoneticFirstName ?? "",
        phoneticLastName: address.phoneticLastName ?? "",
    };
};
